import React from 'react'

export const RetryPayment = () => {
    return (
        <div>RetryPayment</div>
    )
}
